






















import axios from 'axios'
import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import EntryLayout from '@/components/entry/Layout.vue'
import Event, { IEvent } from "@/models/Event"
import { apiV1EventPath } from "@/rails/routes"

@Component({
  components: {
    EntryLayout
  }
})
export default class UserActivation extends VueBase {
  event = new Event()

  get eventId(): number {
    return Number(window.location.pathname.split('/')[2])
  }

  async mounted(): Promise<void> {
    const res = await axios.get<IEvent>(apiV1EventPath(this.eventId))
    this.event = new Event(res.data)
  }

  showRecruit(): void {
    window.open(this.settings.site.recruit, '_blank')
    window.location.href = '/mypage'
  }

  showTop(): void {
    window.open(this.settings.site.top, '_blank')
    window.location.href = '/mypage'
  }
}
